import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';
import { userCredentials, userInfo } from '@web/common';

export const consents = z.object({
  gtcConsent: z.boolean(),
  newsletterConsent: z.boolean().optional(),
});
export class Consents extends createZodDto(consents) {}

export const emailAndConsents = userCredentials
  .pick({ email: true })
  .extend(consents.shape);
export class EmailAndConsents extends createZodDto(emailAndConsents) {}

export const password = userCredentials.pick({ password: true });
export class Password extends createZodDto(password) {}

export const healthData = userInfo.pick({
  height: true,
  yearOfBirth: true,
  gender: true,
});
export class HealthData extends createZodDto(healthData) {}
